import Sortable from 'sortablejs';

export function dossierOverviewEditor(initial = {}) {
  return {
    basePath: initial.basePath || '/admin/wielerploeg/dossiers/overzicht-layout',
    editMode: false,
    saving: false,
    sections: initial.sections || {},
    meta: initial.meta || {},
    _sortable: null,
    _snapshot: null,
    _order: [],

    sectionEnabled(key) {
      return !!(this.sections[key] && this.sections[key].enabled);
    },

    sectionWidth(key) {
      return (this.sections[key] && this.sections[key].width) || 'full';
    },

    setWidth(key, width) {
      if (this.sections[key]) this.sections[key].width = width;
    },

    toggleSection(key) {
      if (this.sections[key]) this.sections[key].enabled = !this.sections[key].enabled;
    },

    domOrder() {
      return Array.from(this.$refs.grid.children)
        .map((el) => el.dataset.key)
        .filter(Boolean);
    },

    enterEdit() {
      this._snapshot = JSON.parse(JSON.stringify(this.sections));
      this._order = this.domOrder();
      this.editMode = true;
      this.$nextTick(() => {
        this._sortable = Sortable.create(this.$refs.grid, {
          handle: '.dash-drag-handle',
          draggable: '.dash-widget',
          animation: 150,
          ghostClass: 'opacity-40',
        });
      });
    },

    _teardown() {
      if (this._sortable) {
        this._sortable.destroy();
        this._sortable = null;
      }
      this.editMode = false;
    },

    cancel() {
      if (this._snapshot) this.sections = this._snapshot;
      const grid = this.$refs.grid;
      this._order.forEach((key) => {
        const el = grid.querySelector(`[data-key="${key}"]`);
        if (el) grid.appendChild(el);
      });
      this._teardown();
    },

    _payload() {
      return this.domOrder().map((key) => ({
        key,
        enabled: this.sectionEnabled(key),
        width: this.sectionWidth(key),
      }));
    },

    _csrf() {
      return document.querySelector('meta[name="csrf-token"]')?.content || '';
    },

    _toast(message, type = 'info') {
      window.dispatchEvent(new CustomEvent('toast', { detail: { message, type } }));
    },

    async _post(url, body = {}) {
      const params = new URLSearchParams({ ...body });
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': this._csrf(),
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: params,
      });
      return res.json().catch(() => ({}));
    },

    async save() {
      if (this.saving) return;
      this.saving = true;
      try {
        const data = await this._post(this.basePath, {
          layout: JSON.stringify(this._payload()),
        });
        if (data.ok) {
          this._teardown();
          this._toast('Overzicht-indeling opgeslagen.', 'success');
        } else {
          this._toast('Opslaan mislukt. Probeer het opnieuw.', 'error');
        }
      } catch {
        this._toast('Opslaan mislukt. Probeer het opnieuw.', 'error');
      } finally {
        this.saving = false;
      }
    },

    resetDefault() {
      this.$dispatch('open-confirm', {
        title: 'Standaard herstellen?',
        message: 'De overzicht-indeling wordt teruggezet naar de standaard.',
        onConfirm: () => this._doReset(),
      });
    },

    async _doReset() {
      try {
        const data = await this._post(`${this.basePath}/reset`);
        if (data.ok) {
          window.location.reload();
        } else {
          this._toast('Herstellen mislukt.', 'error');
        }
      } catch {
        this._toast('Herstellen mislukt.', 'error');
      }
    },
  };
}
